import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../../components/common/Navbar';
import { navigeraTillbaka } from '../../../utils/backNavigation';

/**
 * LoadingErrorStates - Hanterar alla loading, error och auth states för Offert-vyn
 * 
 * @param {Object} props
 * @param {Object} props.user - Inloggad användare
 * @param {boolean} props.loading - Loading state
 * @param {string} props.error - Felmeddelande
 * @param {boolean} props.notFound - Om offert inte hittades
 * @param {boolean} props.embedded - Om komponenten är inbäddad i modal
 * @param {Function} props.getBackDestination - Funktion som returnerar tillbaka-destination
 */
const LoadingErrorStates = ({ 
  user, 
  loading, 
  error, 
  notFound, 
  embedded,
  getBackDestination 
}) => {
  const navigate = useNavigate();

  // Auth required
  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <div className="flex items-center justify-center py-20">
          <div className="text-center">
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Behörighet krävs</h2>
            <p className="text-gray-600 mb-4">Du måste vara inloggad för att se denna sida.</p>
            <button
              onClick={() => navigate('/login')}
              className="bg-leadme-pink text-white px-4 py-2 rounded-lg hover:bg-leadme-pink-dark transition-colors"
            >
              Logga in
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        {!embedded && <Navbar currentUser={user} />}
        <div className="flex items-center justify-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-leadme-pink"></div>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="min-h-screen bg-gray-50">
        {!embedded && <Navbar currentUser={user} />}
        <div className="flex items-center justify-center py-20">
          <div className="text-center">
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Fel uppstod</h2>
            <p className="text-gray-600 mb-4">{error}</p>
            {!embedded && (
              <button
                onClick={() => navigeraTillbaka(navigate, getBackDestination())}
                className="bg-leadme-pink text-white px-4 py-2 rounded-lg hover:bg-leadme-pink-dark transition-colors"
              >
                Tillbaka
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Not found state
  if (notFound) {
    return (
      <div className="min-h-screen bg-gray-50">
        {!embedded && <Navbar currentUser={user} />}
        <div className="flex items-center justify-center py-20">
          <div className="text-center">
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Offert hittades inte</h2>
            <p className="text-gray-600 mb-4">Den begärda offerten kunde inte hittas.</p>
            {!embedded && (
              <button
                onClick={() => navigeraTillbaka(navigate, getBackDestination())}
                className="bg-leadme-pink text-white px-4 py-2 rounded-lg hover:bg-leadme-pink-dark transition-colors"
              >
                Tillbaka
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default LoadingErrorStates;

